import React , { useEffect } from "react";
import axios from 'axios';
import { Link, useNavigate, useParams } from 'react-router-dom';
import {  Formik, Form, Field } from 'formik';
import { styled } from "@mui/material/styles";
import { Backdrop,Box, CircularProgress, LinearProgress, Typography, Breadcrumbs, Paper, Table, TableCell, TableHead, TableContainer} from '@mui/material';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import AssistantIcon from '@mui/icons-material/Assistant';
import GridItem from "../../components/Grid/GridItem.jsx";
import GridContainer from "../../components/Grid/GridContainer.jsx";
import Card from "../../components/Card/Card.jsx";
import CardHeader from "../../components/Card/CardHeader.jsx";
import CardBody from "../../components/Card/CardBody";
import { useTheme } from "@mui/material/styles";
import Button from "../../components/CustomButtons/Button.jsx";
import {useSelector, useDispatch} from 'react-redux';
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { EditorState, convertToRaw } from 'draft-js';
import TableRow from "@mui/material/TableRow";
import TableBody from "@mui/material/TableBody";
import { baseUrl } from '../../components/shared/baseUrl';
import Skeleton from "@mui/material/Skeleton"
import {motion, useCycle, AnimatePresence} from 'framer-motion';
import { upCount, finCount } from "../../reducers/actionCreators";
import styles1 from "../../components/assets/jss/material-dashboard-react/views/dashboardStyle.js";
import { CircularProgressbar,buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import {
  successColor,
  whiteColor,
  grayColor,
  hexToRgb
} from "../../components/assets/jss/material-dashboard-react.js";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  '&.MuiTableCell-head': {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  '&.MuiTableCell-body': {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

const StyledcardTitle = styled('div')({
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
    align: "center"
});

const StyledcardCategory = styled('div')({
    color: "rgba(255,255,255,.62)",
    margin: "0",
    fontSize: "14px",
    marginTop: "0",
    marginBottom: "0"
});

const StyledModal = styled('div')({
    alignItems: 'center',
    justifyContent: 'center',
    position:'absolute',
    top:'20%',
    left:'10%',
    overflowY:'scroll',
    height:'100%',
    display:'block'
});


const StyledModal1 = styled('div')({
    position: 'relative',
    maxWidth: '700px',
    margin : '0 auto',
    padding: '10px 10px 10px 10px',
    background: "rgba(0,0,0,0.5)",
    backgroundColor: 'white',
    borderRadius:'10 px',
    textAlign:'center',
    zIndex: 10
});

const StyledBackdrop = styled('div')({
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    background: "rgba(0,0,0,0.5)",
    zIndex: 10
});


const styles = (theme) =>({
  
   cardTitle: {
      color: 'blue',
      marginTop: "0px",
      minHeight: "auto",
      fontWeight: "300",
      fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
      marginBottom: "3px",
      textDecoration: "none",
      "& small": {
        color: grayColor[1],
        fontWeight: "400",
        lineHeight: "1"
      }
    },
   cardCategory: {
      color: grayColor[0],
      margin: "0",
      fontSize: "14px",
      marginTop: "0",
      paddingTop: "10px",
      marginBottom: "0"
    },
  fontOswald:{
    fontFamily:"Oswald"
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '33.33%',
    flexShrink: 0,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    width: 1000,

  },
  messageArea: {
    height: '65vh',
    overflowY: 'auto'
  },
  backdrop: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    background: "rgba(0,0,0,0.5)",
    zIndex: 10
  },
  table: {
    minWidth: 500,
  }
});


var cla = {
  "_id":"6006f33eef2c0d65ccbf6601",
  "title": "Class IX",
  "teacherId":"5fe192d970d8c633c005da24"
}


var task = ['Observe the numbers {24, 12, 15, 20, 49, 29, 13, 18, 25, 30} and identify pairs with maximum sum', 'Observe the pair of numbers and find a way to calculate pairwise maximum',
 'Write a general method to calculate pairs with maximum pairwise sum', 'Write an algorithm to find a pair of numbers with maximum sum',
'Analyse the algorithm to count maximum number of comparisons used by the algorithm and total extra variables defined in the algorithm', 'Write an algorithm to find a pair of numbers with maximum sum ', 'Comparison of the algorithms attempted previously']



function getSteps() {
  return ['Decomposition', 'Pattern Recognition', 'Abstraction', 'Algorithm design', 'Analysis of Algorithm', 'Solution', 'Reflection'];
}

const hintsactivity5 = [
  { step: 'Decomposition'},
  { step: 'Pattern recognition'},
  { step: 'Abstraction' },
  { step: 'Algorithm design'},
  { step: 'Analysis of Algorithm' },
  { step: 'Final solution'},
  { step: 'Reflection'}
]


const firstStep = () =>{

  return(
    <p> First step</p>
  );
};




export default function Fibonacci(props){
    const [module, setmodule] = React.useState('');
    var interval = null
    const [clas, setclas] = React.useState([]);
    const [loading, setloading] = React.useState(true);
    const [loadhint, setloadhint] = React.useState(false);
    const [Num, setNum] = React.useState(1);
    const theme = useTheme()
    const classes =styles(theme);
    const [loadsupport, setloadsupport] = React.useState(false);
    const user = useSelector(state => state.user)
    const dispatch = useDispatch();
    const [editorState, seteditorState]= React.useState(EditorState.createEmpty())
    const [loadintro, setloadintro] = React.useState(true);
    const [error, seterror] = React.useState('');
    const [expanded, setExpanded] = React.useState(false);
    const [expanded1, setExpanded1] = React.useState(false); 
    const [addition, setaddition] = React.useState('Individual addition');
    const [termsum, settermsum] = React.useState('0');  
    const [num1, setnum1] = React.useState('0');
    const [num2, setnum2] = React.useState('0');
    const [num3, setnum3] = React.useState('0');
    const [num4, setnum4] = React.useState('0');
    const [num5, setnum5] = React.useState('0');
    const [num6, setnum6] = React.useState('0');
    const [num7, setnum7] = React.useState('0');
    const [num8, setnum8] = React.useState('0');
    const [mydata, setmydata] = React.useState('');
    const [totaldata, settotaldata] = React.useState('')    
    const [analytics, setanalytics] = React.useState([]);
    const [animation, cycleAnimation] = useCycle("animateOne", "animateTwo");
    const [myModal, setmyModal] = React.useState(true);
    const [myModalTwo, setmyModalTwo] = React.useState(false);
    const [myModalThree, setmyModalThree] = React.useState(false);
    const [ansType, setansType] = React.useState('');
    const [mysum, setmysum] = React.useState('0');
    const [isSubmit, setisSubmit] = React.useState(false);
    const { classId, sesId, actId } = useParams();
    

    useEffect(() => {

        const CancelToken = axios.CancelToken;
        const source = CancelToken.source();
        const classid = classId; 
        console.log(actId)
        const sessid = sesId;
        console.log(user)
        const loadData=()=>{
          const config = {
            headers: { Authorization: `Bearer ${user.token}` }
        };

        try{
          setclas(cla)
        

          axios.get(`${baseUrl}pyinterpreter/profile/${sessid}`,config, { cancelToken: source.token })
          .then((response) =>{
            //console.log(response.data)
            settotaldata(response.data)
            var n = 'activity'+actId
            const totaldata = response.data
            const activity =response.data[n]
            console.log(activity)
            var profileScore=0
            var previousScore = 60
            var minutesDeco=0
            var minutesPat=0
            var minutesAbs=0
            var minutesAlgo=0
            var minutesAn=0
            var totalAlternate=0
            var minutesDecoAlt=0
            var minutesPatAlt=0
            var minutesAbsAlt=0
            var minutesAlgoAlt=0
            var minutesAnAlt=0
            //console.log(activity)
            setmydata(activity[0])

            ////for decomposition
            var startDeco = new Date(activity[0].decomposition[0].created) 
            var finalDeco = new Date(activity[0].decomposition[0].finalTime)
            if(startDeco<finalDeco){
                minutesDeco = (finalDeco - startDeco)/(1000*60)
            }
            ///for alternate in decomposition
            activity[0].decomposition[0].alternateSolution.map((text,index)=>{
                var altstart = new Date(text.created)
                var altfinal = new Date(text.finalTime)
                if(altstart<altfinal){
                    var diff = (altfinal - altstart)/(1000*60)
                }
                totalAlternate=totalAlternate+diff
            })
            minutesDecoAlt=totalAlternate
            minutesDeco=minutesDeco-totalAlternate
            console.log(minutesDeco +' '+typeof(minutesDeco)+' '+Number(minutesDeco))
            if(Number.isNaN(minutesDeco)==true){
              minutesDeco=10
            }
            if(Number.isNaN(minutesDecoAlt)==true){
              minutesDecoAlt=10
            }

            ////for pattern
                totalAlternate=0
                startDeco = new Date(activity[0].pattern[0].created) 
                finalDeco = new Date(activity[0].pattern[0].finalTime)
            if(startDeco<finalDeco){
                minutesPat = (finalDeco - startDeco)/(1000*60)
            } 
            ///for alternate in pattern
            activity[0].pattern[0].alternateSolution.map((text,index)=>{
                var altstart = new Date(text.created)
                var altfinal = new Date(text.finalTime)
                if(altstart<altfinal){
                    var diff = (altfinal - altstart)/(1000*60)
                }
                totalAlternate=totalAlternate+diff
            })
            minutesPatAlt=totalAlternate
            minutesPat=minutesPat-totalAlternate
            if(Number.isNaN(minutesPat)==true){
              minutesPat=10
            }
            if(Number.isNaN(minutesPatAlt)==true){
              minutesPatAlt=10
            }
            /////for abstraction
            totalAlternate=0
            startDeco = new Date(activity[0].abstraction[0].created) 
            finalDeco = new Date(activity[0].abstraction[0].finalTime)
            if(startDeco<finalDeco){
                minutesAbs = (finalDeco - startDeco)/(1000*60)
            }
            
            ///for alternate in abstraction
            activity[0].abstraction[0].alternateSolution.map((text,index)=>{
                var altstart = new Date(text.created)
                var altfinal = new Date(text.finalTime)
                if(altstart<altfinal){
                    var diff = (altfinal - altstart)/(1000*60)
                }
                totalAlternate=totalAlternate+diff
            })
            minutesAbsAlt=totalAlternate
            minutesAbs=minutesAbs-totalAlternate
            if(Number.isNaN(minutesAbs)==true){
              minutesAbs=10
            }
            if(Number.isNaN(minutesAbsAlt)==true){
              minutesAbsAlt=10
            }
            /////for algorithm
            totalAlternate=0
            startDeco = new Date(activity[0].algorithm[0].created) 
            finalDeco = new Date(activity[0].algorithm[0].finalTime)
            if(startDeco<finalDeco){
                minutesAlgo = (finalDeco - startDeco)/(1000*60)
            }

            ///for alternate in algorithm
            activity[0].algorithm[0].alternateSolution.map((text,index)=>{
                var altstart = new Date(text.created)
                var altfinal = new Date(text.finalTime)
                if(altstart<altfinal){
                    var diff = (altfinal - altstart)/(1000*60)
                }
                totalAlternate=totalAlternate+diff
            })
            minutesAlgoAlt=totalAlternate
            minutesAlgo=minutesAlgo-totalAlternate
            if(Number.isNaN(minutesAlgo)==true){
              minutesAlgo=10
            }
            if(Number.isNaN(minutesAlgoAlt)==true){
              minutesAlgoAlt=10
            }
            //////for analysis
            totalAlternate=0
            startDeco = new Date(activity[0].analysis[0].created) 
            finalDeco = new Date(activity[0].analysis[0].finalTime)
            if(startDeco<finalDeco){
                minutesAn = (finalDeco - startDeco)/(1000*60)
            } 
            ///for alternate in analysis            
            minutesAnAlt=totalAlternate
            if(Number.isNaN(minutesAn)==true){
              minutesAn=10
            }
            if(Number.isNaN(minutesAnAlt)==true){
              minutesAnAlt=10
            }
        
            var analyticStatus = [];              
      
                analyticStatus.push({
                    step:'Decomposition',
                    attempts:activity[0].decomposition[0].noOfattempts,
                    altattempts:activity[0].decomposition[0].noOfaltattempts,
                    hints:activity[0].decomposition[0].levelOfHints,
                    time:minutesDeco.toFixed(2),
                    alttime:minutesDecoAlt.toFixed(2)
                })
                analyticStatus.push({
                    step:'Pattern',
                    attempts:activity[0].pattern[0].noOfattempts,
                    altattempts:activity[0].pattern[0].noOfaltattempts,
                    hints:activity[0].pattern[0].levelOfHints,
                    time:minutesPat.toFixed(2),
                    alttime:minutesPatAlt.toFixed(2)
                })
                analyticStatus.push({
                    step:'Abstraction',
                    attempts:activity[0].abstraction[0].noOfattempts,
                    altattempts:activity[0].abstraction[0].noOfaltattempts,
                    hints:activity[0].abstraction[0].levelOfHints,
                    time:minutesAbs.toFixed(2),
                    alttime:minutesAbsAlt.toFixed(2)
                })
                analyticStatus.push({
                    step:'Algorithm',
                    attempts:activity[0].algorithm[0].noOfattempts,
                    altattempts:activity[0].algorithm[0].noOfaltattempts,
                    hints:activity[0].algorithm[0].levelOfHints,
                    time:minutesAlgo.toFixed(2),
                    alttime:minutesAlgoAlt.toFixed(2)
                })
                analyticStatus.push({
                    step:'Analysis',
                    attempts:activity[0].analysis[0].noOfattempts,
                    altattempts:activity[0].analysis[0].noOfaltattempts,
                    hints:activity[0].analysis[0].levelOfHints,
                    time:minutesAn.toFixed(2),
                    alttime:minutesAnAlt.toFixed(2)
                })
                var hintscore=0
                var attscore=0
                var timescore=0
                analyticStatus.map((text,index)=>{
                    
                    if(text.hints=='Basic'){
                        hintscore=hintscore+3
                    }
                    if(text.hints=='Intermediate'){
                        hintscore=hintscore+2
                    }
                    if(text.hints=='Advanced'){
                        hintscore=hintscore+1
                    }
                    attscore=attscore+parseInt(text.attempts)
                    timescore=timescore+Number(text.time)
                })
                
                timescore = timescore%100
                if(Number(timescore)<50){
                    timescore=50
                }
                console.log(analyticStatus)
                console.log('My scores '+attscore+', '+hintscore+', '+timescore)
                
                profileScore=hintscore+50/attscore+500/timescore
              
                profileScore=(profileScore/35)*100
                previousScore = Number(activity[0].profileScore)

                var prevactNo=1
                if(prevactNo>1){
                  prevactNo=Number(actId)-1
                }
                var prevAct = 'activity'+prevactNo
                var prevActivity=response.data[prevAct]
                console.log(prevActivity)

                var indexprev=0
                var indexcurr=0
                var lev = [{mode:'easy'},{mode:'medium'},{mode:'hard'}]
                
                  lev.map((text,index)=>{
                  if(prevActivity[0].level==text.mode){
                    indexprev=index
                  }
                  if(activity[0].level==text.mode){
                    indexcurr=index
                  }
                })
                var k=1
                if(indexprev===indexcurr){
                  k=2
                }
                else if(indexprev<indexcurr){
                  k=3
                }

                console.log(k)
                if(previousScore>profileScore){
                    profileScore=(profileScore+k*previousScore)/(1+k)
                }
                else{
                    profileScore=(previousScore+k*profileScore)/(1+k)
                }
                console.log(profileScore)

                setmysum(0)
                ///Update profile directly///////////////////////////////////////////////

                var problemtype = 'medium'/////////set problemtype here
                if(profileScore<40){
                    problemtype='easy'
                }
                if(profileScore>75){
                    problemtype='hard'
                }
                //problemtype='easy'
                var num = actId
                var newact = parseInt(num)+1
                var newactivity='activity'+newact
                var newarr = totaldata[newactivity]
                console.log(newarr)
          
                  if(Number(newarr[0].profileScore)>0){ 
                    console.log('profile score already updated')  
                    setmysum(Math.ceil(profileScore * 100)/100)
                      setanalytics(analyticStatus)
                      getData(sessid)
                      setloading(false)            
                  }
                  else{
                      newarr[0].level=problemtype
                      newarr[0].profileScore=profileScore
                      newarr[0].decomposition[0].created=new Date()
              
                        const data=
                        {
                          act: newactivity,
                          data: newarr[0]
                        }                     
                        console.log(data)
                    
                        axios.put(`${baseUrl}pyinterpreter/profile/${sesId}`, data)
                        .then((response) => {
                          settotaldata(response.data)  
                          setmysum(Math.ceil(profileScore * 100)/100)
                          setanalytics(analyticStatus)
                          getData(sessid)
                          setloading(false)
                      
                        })
                  }
                  
                
                ////////////////////////////////////////////////////////////////////


                // interval = setInterval(()=>{
                //     setmysum(Math.ceil(profileScore * 100)/100)
                    
                // },3000)
                // setanalytics(analyticStatus)
                // getData(sessid)

                // try{
                //         getData(sessid)
                //         interval = setInterval(() => {
                //             //console.log('Interval is working')
                //             getData(sessid);
                //             updateCount(user.count)
                //         }, 3000);
                
                   
                //   } catch (error) {
                //       if (axios.isCancel(error)) {
                //         console.log("cancelled");
                //       } else {
                //         throw error;
                //       }
                //     }

          })
          .catch((error)=>{
          console.log(error);
          });
        } catch (error) {
        if (axios.isCancel(error)) {
          console.log("cancelled");
        } else {
          throw error;
        }
      }

    };

    loadData();

   
    return() => {source.cancel();
    };


    }, []);

    useEffect(() => {  
      clearInterval(interval);
  
     })


 
  
     const backdrop = {
      visible:{opacity: 1},
      hidden:{opacity: 0}
  }
  
  const modal = {
      hidden:{
        y:"-100vh",
        opacity: 1
      },
      visible:{
        y: "50px",
        opacity:1,
        transition:{ delay: 0.5 }
      },
      exit:{
        y:"500vh",
        opacity: 1,
        transition:{ delay: 1 }
  
      },
    }
  
   
    const commaToText = (txt) =>{
      var mytext = ''
      if(txt!='' && typeof(txt)!=='undefined'){ 
      if(txt.includes(',')==true){
        var newArr = txt.split(',')
        var i=0
        while(newArr[i]!==''&& i<newArr.length && newArr[i]!=='undefined'){
              mytext=mytext+' '+newArr[i]
              i=i+1
          }  
        
         return mytext
      }
      else{
        return txt
      }
    }
    return txt
      
   }
  
  

     const solutionIndex = () =>{
       var len=0
      if(typeof(mydata.decomposition[0].alternateSolution.length)!='undefined'){
        len=mydata.decomposition[0].alternateSolution.length
      }
      if(typeof(mydata.pattern[0].alternateSolution.length)!='undefined'){
        len=len+mydata.pattern[0].alternateSolution.length
      }
      if(typeof(mydata.abstraction[0].alternateSolution.length)!='undefined'){
        len=len+mydata.abstraction[0].alternateSolution.length
      }
      return len;

     }

    

    const closeModal=()=>{
      setmyModal(!myModal)
    }
    const closeModalTwo=()=>{
      setmyModalTwo(!myModalTwo)
    }
    const closeModalYesThree=()=>{
            
      setmyModalThree(!myModalThree)
      var problemtype = 'medium'/////////set problemtype here
      if(mysum<40){
          problemtype='easy'
      }
      if(mysum>75){
          problemtype='hard'
      }
      //problemtype='easy'
      var num = actId
      var newact = parseInt(num)+1
      var newactivity='activity'+newact
      var newarr = totaldata[newactivity]
      console.log(newarr)

        if(newarr[0].decomposition[0].completed===false){               
            newarr[0].level=problemtype
        }
        
        newarr[0].profileScore=mysum
        newarr[0].decomposition[0].created=new Date()

          const data=
          {
            act: newactivity,
            data: newarr[0]
          }                     
          console.log(data)
      
          axios.put(`${baseUrl}pyinterpreter/profile/${sesId}`, data)
          .then((response) => {
              console.log(response.data)
              var act = 'activity'+num
              response.data.currentActivity=newactivity
              response.data[act][0].profileScore=mysum
              console.log('updating profile')
              const mdata=
              {
                profile: response.data
              }                     
              console.log(mdata)
        
              axios.put(`${baseUrl}pyinterpreter/profile/${sesId}`, mdata)
              .then((response) => {
            
              history(`/student/dashboard/viewstudentclass/${clas._id}/session/${sesId}/${newactivity}${problemtype}`)
        
            })
    })
}


 

    const closeModalNoThree=()=>{
      setmyModalThree(!myModalThree)

    }

    

    const updateCount = (count) =>{
      //console.log(count)
      
      setNum(count)

      if(count<=user.fcount)
      {
        count=count+1
        dispatch(
          upCount(count)
        )
      }
      
    }

    

  const getData = (sessid) =>{
      const config = {
        headers: { Authorization: `Bearer ${user.token}` }
    };
      const CancelToken = axios.CancelToken;
      const source = CancelToken.source();
      //var num = Num+1
      //setNum(num)
      axios.get(`${baseUrl}pyinterpreter/profile/${sessid}`,config, { cancelToken: source.token })
          .then((response) =>{
            //console.log(response.data)
            var n = 'activity'+actId
            const activity =response.data[n]
            settotaldata(response.data)
            //console.log(activity)
            setmydata(activity[0])
           
  
      })
    
  }

  ////////////Code for Stepper////////////////////////////

  const [activeStep, setActiveStep] = React.useState(0);
  const steps = getSteps();

  const handleNext = () => {
    var comp=false; 
      var num = actId
      var newact = parseInt(num)+1
      var newactivity='activity'+newact
      var newarr = totaldata[newactivity]
    if(newarr[0].problemStatement!=''){                       
        history(`/student/dashboard/viewstudentclass/${clas._id}/session/${sesId}/${newactivity}${newarr[0].level}`)
        setisSubmit(false)
        comp=true
    }
   if(comp===false){
     console.log('Not completed step')
    setmyModalThree(!myModalThree)
    setisSubmit(false)
   } 

  };

  const handlePostTest = () =>{

    history(`/student/dashboard/viewstudentclass/${clas._id}/session/${sesId}/activityposttest`)
  }


  /////////////////////////////////////////////////////


 

    const ToggleHint = () =>{
      if(loadhint==true){
      setloadhint(false)
      }
      else{
        setloadhint(true)
      }
    } 
    
    const Togglesupport = () =>{
      setloadsupport(!loadsupport)
      
    }



      const handleAccordionChange = (panel) => (event, isExpanded) => {
        setloadintro(false)
        if(panel==='panel8'){
          if(isExpanded===true){
            setmyModalTwo(!myModalTwo)
          }
        }
        setExpanded(isExpanded ? panel : false);
      };

      const handleAccordionChange1 = (panel) => (event, isExpanded) => {
        
        setExpanded1(isExpanded ? panel : false);
      };


      function MyCustomUploadAdapterPlugin(editor){
        editor.plugins.get( 'FileRepository' ).createUploadAdapter = (loader) => {
          return new MyUploadAdapter(loader)
        }
      }

      class MyUploadAdapter {
        constructor(props) {
            // CKEditor 5's FileLoader instance.
          this.loader = props;
          // URL where to send files.
          this.url = `${baseUrl}fileupload/files`;
        }
    
        // Starts the upload process.
        upload() {
          return this.loader.file
              .then( file => new Promise( ( resolve, reject ) => {
  
                  const toBase64 = file => new Promise((resolve, reject) => {
                      const reader = new FileReader();
                      reader.readAsDataURL(file);
                      reader.onload = () => resolve(reader.result);
                      reader.onerror = error => reject(error);
                  });
                  
                  return toBase64(file).then(cFile=>{
                    console.log(file)
                    const data=new FormData();
                    data.append('file', file)   
                    var filename = '';
                  axios.post(`${baseUrl}fileupload/files`, data)
                          .then((response) => {
                              console.log(response.data.file.filename)
                              filename = response.data.file.filename;
                              resolve({ 
                                default: `${baseUrl}fileupload/files/${filename}` 
                              })
                          })
                          .catch((error)=>{
                              reject(`Couldn't upload file: ${ file.name }.`)
                            console.log(error);
                            });
                          })
                  
              } ) );
      }
    
    }

   

      



      const custom_config = {
        extraPlugins: [ MyCustomUploadAdapterPlugin ],
        
        // toolbar: {
        //   items: [
        //     'heading',
        //     '|',
        //     'bold',
        //     'italic',
        //     'link',
        //     'bulletedList',
        //     'numberedList',
        //     '|',
        //     'blockQuote',
        //     'insertTable',
        //     '|',
        //     'imageUpload',
        //     'undo',
        //     'MathType',
        //     'SpecialCharacters',
        //     'SpecialCharactersMathematical',
        //     'redo',
        //     'Subscript', 
        //     'Superscript',            
        //   ]
        // }
        // ,
        // table: {
        //   contentToolbar: [ 'tableColumn', 'tableRow', 'mergeTableCells' ]
        // }
      }



      const totalSolutionComparison =(deco,pattern,abs,algorithm,time,space,len,k,step)=>{

        const algoText = (txt) =>{
          var tex = txt.split(';')
          return (<div>
              {tex.length==4?
              <GridContainer>
                  <GridItem xs={12} sm={12} md={5}>
                      input statement:
                  </GridItem>
                  <GridItem xs={12} sm={12} md={7}>
                       {commaToText(tex[0])}
                  </GridItem>
                  <GridItem xs={12} sm={12} md={5}>
                      define variable:
                  </GridItem>
                  <GridItem xs={12} sm={12} md={7} >
                       {commaToText(tex[1])} 
                  </GridItem>
                  <GridItem xs={12} sm={12} md={5}>
                      set variable:
                  </GridItem>
                  <GridItem xs={12} sm={12} md={7} >
                      {commaToText(tex[2])}
                  </GridItem>
                  <GridItem xs={12} sm={12} md={5}>
                      output statement:
                  </GridItem>
                  <GridItem xs={12} sm={12} md={7} >
                      {commaToText(tex[3])}
                  </GridItem>
              </GridContainer>:
              <GridContainer>
                  <GridItem xs={12} sm={12} md={5}>
                      input statement:
                  </GridItem>
                  <GridItem xs={12} sm={12} md={7}>
                      {commaToText(tex[0])}
                  </GridItem>
                  <GridItem xs={12} sm={12} md={5}>
                      define variable:
                  </GridItem>
                  <GridItem xs={12} sm={12} md={7} >
                      {commaToText(tex[1])} {commaToText(tex[2])}
                  </GridItem>
                  <GridItem xs={12} sm={12} md={5}>
                      set variable:
                  </GridItem>
                  <GridItem xs={12} sm={12} md={7} >
                      {commaToText(tex[3])}
                  </GridItem>
                  <GridItem xs={12} sm={12} md={5}>
                      output statement:
                  </GridItem>
                  <GridItem xs={12} sm={12} md={7} >
                      {commaToText(tex[4])}
                  </GridItem>
              </GridContainer>}
              </div>
          )
        }
          return (
            <>
                <Card >
                      <b align="center"> Your Solution {len}</b>
                  <CardBody>
                    <b sx={{ fontFamily: "Oswald" }}> Decomposition </b>
                    <p style={step=='decomposition'?{ ...classes.cardTitle }:null}>{commaToText(deco)}</p>
                    <b sx={{ fontFamily: "Oswald" }}> Pattern </b>
                    <p style={step=='pattern'?{ ...classes.cardTitle }:null}>{commaToText(pattern)}</p>
                    <b sx={{ fontFamily: "Oswald" }}> Abstraction </b>
                    <p style={step=='abstraction'?{ ...classes.cardTitle }:null}>{commaToText(abs)}</p>
                    <b sx={{ fontFamily: "Oswald" }}> Algorithm </b>
                    <p style={step=='algorithm'?{ ...classes.cardTitle }:null}>{algoText(algorithm)}</p>
                    <b sx={{ fontFamily: "Oswald" }}> Analysis</b>
                    <p style={classes.cardCategory}>
                      No. of operations={time},No. of variables={space}       </p>
                  </CardBody>
                </Card>
              </>              
              );
            }



const history = useNavigate();




    return(
    loading!==true?
      <div>
          <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            {totaldata.currentActivity!='activity7'?
            <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />} aria-label="breadcrumb">
              <Link color="inherit" to="/student/dashboard">
                Dashboard
              </Link>
              <Link color="inherit" to={`/student/dashboard/viewsession/${classId}`}>
                <Typography color="textPrimary">{clas.title}</Typography>
              </Link>
              {loading!==true?        
              <Link color="inherit" to={`/student/dashboard/viewstudentclass/${clas._id}/session/${totaldata.sessionId}/profile/${sesId}/scenario`}>
                <Typography color="textPrimary"> Scenario </Typography>
              </Link>:null}
              <Link to={`/student/dashboard/viewstudentclass/${clas._id}/session/${sesId}/activity${actId}${mydata.level}`} >
                <Typography color="textPrimary">Activity{actId}</Typography>
              </Link>
              <Typography color="textPrimary"> Analytics </Typography>

            </Breadcrumbs>
            :
            <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />} aria-label="breadcrumb">
              <Link color="inherit" to="/student/home">
                Home
              </Link>
              <Link to={`/student/dashboard/viewstudentclass/${clas._id}/session/${sesId}/activitydemo`} >
                <Typography color="textPrimary">Demo activity</Typography>
              </Link>
                <Typography color="textPrimary"> Analytics </Typography>

            </Breadcrumbs>}
            {/* {console.log({...sess}.title)} */}
          </GridItem>
            <GridItem xs={12} sm={12} md={12} >
              <Typography variant="h4" align="center" sx={{ fontFamily: "Oswald" }}>
                Observations from Activity
              </Typography>
            </GridItem>

        <GridItem xs={12} sm={12} md={3} >
         
        </GridItem>
        </GridContainer>

                  <Formik
                    initialValues={{
                    hypothesis: '',
                    }}


                    onSubmit={(values, {setSubmitting}) => {
                     setTimeout(() => {
                        setSubmitting(false);
                   
                    alert(JSON.stringify('Saving...', null, 2));

                        var decompos=''
                        var sum1=parseInt(num1)+parseInt(num2);
                        var sum2=parseInt(num3)+parseInt(num4);
                        var sum3=parseInt(num5)+parseInt(num6);
                        var sum4=parseInt(num7)+parseInt(num8);
                        
                        decompos ='Pairs are-first,second:,(,'+num1+','+num2+',)='+sum1+',first,last:,(,'+num3+','+num4+',)='+sum2+',first,second last:,(,'+num5+','+num6+',)='+sum3+',maximum sum, pair:,(,'+num7+','+num8+',)='+sum4
                        seterror('')
                        mydata.decomposition[0].userText=decompos

                        const data=
                        {
                          act: 'activity5',
                          decomposition: mydata.decomposition
                        }                     
                        console.log(data)

                      axios.put(`${baseUrl}pyinterpreter/profile/${sesId}`, data)
                      .then((response) => {
                          console.log(response.data)
                          const activity = response.data.activity5[0]
                          setmydata(activity)
                      })
                     }, 500);
                    }}
                >

          {({submitForm, isSubmitting, touched, errors}) => (
          <Form>
          {loading!==true?

            <GridContainer>
                          
{/**''''''''''''''''''''''''''''''''Code for Hints''''''''''''''''''''''''''''''''''''''''''''''''''''''''''''''*/}

            {myModal && (
            <AnimatePresence exitBeforeEnter>
                <motion.div
                variants={backdrop}
                initial="hidden"
                animate="visible"
                exit={{  zIndex: 0,
                  x: -1000,
                  opacity:0,
                }}
               
                >
                  <StyledBackdrop>
                  <motion.div 
                    variants={modal} 
                    >
                      <StyledModal1>
                      <h4> Analytics part </h4>
                      <GridContainer>
                        <GridItem xs={12} sm={12} md={3}>
                        <img alt='Marine Life' width="60" height="150" className="card-img-top" src={baseUrl+'assets/images/pandaCongrats.JPG'} />
                        </GridItem> 
                        <GridItem xs={12} sm={12} md={9}>
                          <h5 sx={{ fontFamily: "Oswald" }}><b> Congratulations, You completed the Activity.!!! </b></h5>
                          <p sx={{ fontFamily: "Oswald" }}>Check your current profile score.</p>
                          <p sx={{ fontFamily: "Oswald" }}> Observe the number of attempts, level of hints, and total time taken by you in each step.</p>
                          <p sx={{ fontFamily: "Oswald" }}>Try to analyze your performance and improve it in the next activity</p>
                        </GridItem>
                      </GridContainer>
                      <Button color="success" variant="contained" onClick={closeModal} 
                        title="Click here to  proceed" style={{ fontSize: '10px' }} >
                          OK
                      </Button>
                    </StyledModal1>
                  </motion.div>
                  </StyledBackdrop>
                </motion.div>
            </AnimatePresence>)}

            {hintsactivity5.map((text, index)=>(
              index===activeStep?
              myModalTwo && (
              <AnimatePresence exitBeforeEnter>
                <motion.div 
                variants={backdrop}
                initial="hidden"
                animate="visible"
                exit={{  zIndex: 0,
                  x: -1000,
                  opacity:0,
                }}
               
                >
                  <StyledBackdrop>>
                  <motion.div 
                    variants={modal} 
                    >
                    <StyledModal1>
                     
                      <subtitle1> {ansType} </subtitle1>
                      <h5> Current Step: {hintsactivity5[index].step} 
                      {activeStep === 0?mydata.decomposition[0].proceed===true && mydata.decomposition[0].completed===false?' (Submitted)':'':
                      activeStep === 1?mydata.pattern[0].proceed===true && mydata.pattern[0].completed===false?' (Submitted)':'':
                      activeStep === 2?mydata.abstraction[0].proceed===true && mydata.abstraction[0].completed===false?' (Submitted)':'':
                      activeStep === 3?mydata.algorithm[0].proceed===true && mydata.algorithm[0].completed===false?' (Submitted)':'':
                      mydata.analysis[0].proceed===true && mydata.analysis[0].completed===false?' (Submitted)':''}

                      {activeStep === 0?mydata.decomposition[0].completed===true?' (Completed)':'':
                      activeStep === 1?mydata.pattern[0].completed===true?' (Completed)':'':
                      activeStep === 2?mydata.abstraction[0].completed===true?' (Completed)':'':
                      activeStep === 3?mydata.algorithm[0].completed===true?' (Completed)':'':
                      activeStep === 4?mydata.analysis[0].completed===true?' (Completed)':'':null} </h5>
                      {mydata.analysis[0].completed===false?<h5> Your Task: {task[activeStep]}</h5>:null}
                      
                      {(mydata.altStep==='' && mydata.decomposition[0].noOfattempts>1 && (index===0 && mydata.decomposition[0].levelOfHints==='Basic' || index===0 && mydata.decomposition[0].levelOfHints==='Intermediate' || index===0 && mydata.decomposition[0].levelOfHints==='Advanced')) || (mydata.altStep==='decomposition' && mydata.decomposition[0].noOfattempts>1 && (index===0 && mydata.decomposition[0].levelOfHints==='Basic' || index===0 && mydata.decomposition[0].levelOfHints==='Intermediate' || index===0 && mydata.decomposition[0].levelOfHints==='Advanced'))? 
                        <GridItem xs={12} sm={12} md={12}>
                        <b> Basic Hint: </b> {mydata.decomposition[0].hints[0].basic}          
                        </GridItem>
                      :null}
                      {(mydata.altStep==='' && (index===0 && mydata.decomposition[0].levelOfHints==='Intermediate' || index===0 && mydata.decomposition[0].levelOfHints==='Advanced')) || (mydata.altStep==='decomposition' && (index===0 && mydata.decomposition[0].levelOfHints==='Intermediate' || index===0 && mydata.decomposition[0].levelOfHints==='Advanced'))? 
                        <GridItem xs={12} sm={12} md={12}>
                        <b> Intermediate Hint: </b>  {mydata.decomposition[0].hints[0].intermediate}           
                        </GridItem>
                      :null}
                      {(mydata.altStep==='' && index===0 && mydata.decomposition[0].levelOfHints==='Advanced') || (mydata.altStep==='decomposition' && index===0 && mydata.decomposition[0].levelOfHints==='Advanced')? 
                        <GridItem xs={12} sm={12} md={12}>
                        <b> Advanced Hint: </b>  {mydata.decomposition[0].hints[0].advanced}           
                        </GridItem>
                      :null}
                      {(mydata.altStep===''&& (mydata.pattern[0].noOfattempts>1 && index===1 && mydata.pattern[0].levelOfHints==='Basic' || index===1 && mydata.pattern[0].levelOfHints==='Intermediate' || index===1 && mydata.pattern[0].levelOfHints==='Advanced'))|| (mydata.altStep==='pattern' && mydata.pattern[0].noOfattempts>1 && index===1 && mydata.pattern[0].levelOfHints==='Basic' || index===1 && mydata.pattern[0].levelOfHints==='Intermediate' || index===1 && mydata.pattern[0].levelOfHints==='Advanced')? 
                        <GridItem xs={12} sm={12} md={12}>
                        <b> Basic Hint: </b>  {mydata.pattern[0].hints[0].basic}          
                        </GridItem>
                      :null}
                      {(mydata.altStep==='' && (index===1 && mydata.pattern[0].levelOfHints==='Intermediate' || index===1 && mydata.pattern[0].levelOfHints==='Advanced'))|| (mydata.altStep==='pattern' && (index===1 && mydata.pattern[0].levelOfHints==='Intermediate' || index===1 && mydata.pattern[0].levelOfHints==='Advanced'))? 
                        <GridItem xs={12} sm={12} md={12}>
                        <b> Intermediate Hint: </b> {mydata.pattern[0].hints[0].intermediate}           
                        </GridItem>
                      :null}
                      {(mydata.altStep==='' && index===1 && mydata.pattern[0].levelOfHints==='Advanced') || (mydata.altStep==='pattern' && index===1 && mydata.pattern[0].levelOfHints==='Advanced')? 
                        <GridItem xs={12} sm={12} md={12}>
                        <b> Advanced Hint: </b> {mydata.pattern[0].hints[0].advanced}           
                        </GridItem>
                      :null}

                      {(mydata.altStep==='' && mydata.abstraction[0].noOfattempts>1 &&activeStep===2 && mydata.abstraction[0].levelOfHints==='Basic' || activeStep===2 && mydata.abstraction[0].levelOfHints==='Intermediate' || activeStep===2 && mydata.abstraction[0].levelOfHints==='Advanced')|| (mydata.altStep==='abstraction' && mydata.abstraction[0].noOfattempts>1 &&activeStep===2 && mydata.abstraction[0].levelOfHints==='Basic' || activeStep===2 && mydata.abstraction[0].levelOfHints==='Intermediate' || activeStep===2 && mydata.abstraction[0].levelOfHints==='Advanced')? 
                        <GridItem xs={12} sm={12} md={12}>
                        <b>Basic Hint:</b> {mydata.abstraction[0].hints[0].basic}          
                        </GridItem>
                      :null}
                      {(mydata.altStep==='' && activeStep===2 && mydata.abstraction[0].levelOfHints==='Intermediate' || activeStep===2 && mydata.abstraction[0].levelOfHints==='Advanced') || (mydata.altStep==='abstraction' && activeStep===2 && mydata.abstraction[0].levelOfHints==='Intermediate' || activeStep===2 && mydata.abstraction[0].levelOfHints==='Advanced')? 
                        <GridItem xs={12} sm={12} md={12}>
                        <b> Intermediate Hint:</b>  {mydata.abstraction[0].hints[0].intermediate}           
                        </GridItem>
                      :null}
                      {(mydata.altStep==='' && activeStep===2 && mydata.abstraction[0].levelOfHints==='Advanced')|| (mydata.altStep==='abstraction' && activeStep===2 && mydata.abstraction[0].levelOfHints==='Advanced')? 
                        <GridItem xs={12} sm={12} md={12}>
                        <b> Advanced Hint: </b> {mydata.abstraction[0].hints[0].advanced}           
                        </GridItem>
                      :null}

                      {(mydata.altStep==='' && mydata.algorithm[0].noOfattempts>1 && activeStep===3 && mydata.algorithm[0].levelOfHints==='Basic' || activeStep===3 && mydata.algorithm[0].levelOfHints==='Intermediate' || activeStep===3 && mydata.algorithm[0].levelOfHints==='Advanced') || (mydata.altStep==='algorithm' && mydata.algorithm[0].noOfattempts>1 && activeStep===3 && mydata.algorithm[0].levelOfHints==='Basic' || activeStep===3 && mydata.algorithm[0].levelOfHints==='Intermediate' || activeStep===3 && mydata.algorithm[0].levelOfHints==='Advanced')? 
                        <GridItem xs={12} sm={12} md={12}>
                        <b> Basic Hint: </b> {mydata.algorithm[0].hints[0].basic}          
                        </GridItem>
                      :null}
                      {(mydata.altStep==='' && activeStep===3 && mydata.algorithm[0].levelOfHints==='Intermediate' || activeStep===3 && mydata.algorithm[0].levelOfHints==='Advanced') || (mydata.altStep==='algorithm' && activeStep===3 && mydata.algorithm[0].levelOfHints==='Intermediate' || activeStep===3 && mydata.algorithm[0].levelOfHints==='Advanced')? 
                        <GridItem xs={12} sm={12} md={12}>
                        <b> Intermediate Hint: </b> {mydata.algorithm[0].hints[0].intermediate}           
                        </GridItem>
                      :null}
                      {(mydata.altStep==='' && activeStep===3 && mydata.algorithm[0].levelOfHints==='Advanced') || (mydata.altStep==='algorithm' && activeStep===3 && mydata.algorithm[0].levelOfHints==='Advanced')? 
                        <GridItem xs={12} sm={12} md={12}>
                        <b> Advanced Hint: </b> {mydata.algorithm[0].hints[0].advanced}           
                        </GridItem>
                      :null}

                      {(mydata.altStep==='' && mydata.analysis[0].noOfattempts>1 && activeStep===4 && mydata.analysis[0].levelOfHints==='Basic' || activeStep===4 && mydata.analysis[0].levelOfHints==='Intermediate' || activeStep===4 && mydata.analysis[0].levelOfHints==='Advanced')? 
                        <GridItem xs={12} sm={12} md={12}>
                        <b> Basic Hint: </b> {mydata.analysis[0].hints[0].basic}          
                        </GridItem>
                      :null}
                      {(mydata.altStep==='' && activeStep===4 && mydata.analysis[0].levelOfHints==='Intermediate' || activeStep===4 && mydata.analysis[0].levelOfHints==='Advanced')? 
                        <GridItem xs={12} sm={12} md={12}>
                        <b> Intermediate Hint: </b> {mydata.analysis[0].hints[0].intermediate}           
                        </GridItem>
                      :null}
                      {(mydata.altStep==='' && activeStep===4 && mydata.analysis[0].levelOfHints==='Advanced')? 
                        <GridItem xs={12} sm={12} md={12}>
                        <b> Advanced Hint: </b> {mydata.analysis[0].hints[0].advanced}           
                        </GridItem>
                      :null}
                      
                      {activeStep===5 && mydata.analysis[0].completed===false? 
                        <GridItem xs={12} sm={12} md={12}>
                          <b> Your solution </b>
                          <GridItem xs={12} sm={12} md={12}>
                            {mydata.analysis[0].hints[0].basic}          
                          </GridItem>            
                        </GridItem>
                      :null}
                      {activeStep===6 ? 
                        <GridItem xs={12} sm={12} md={12}>
                          <b> Observe the solutions in Your previous attempts tab above consisting of your attempted solutions and all possible solutions. Compare the solutions  </b>            
                        </GridItem>
                      :null}
                      
                      <Button color="success" variant="contained" onClick={closeModalTwo} 
                      title="Click here to  proceed" style={{ fontSize: '10px' }} >
                        OK
                    </Button>
                    </StyledModal1>
                    </motion.div>  
                  </StyledBackdrop>
                </motion.div>
              </AnimatePresence>)
              :null
            ))
            }

              {myModalThree && (
              <AnimatePresence exitBeforeEnter>
                <motion.div
                variants={backdrop}
                initial="hidden"
                animate="visible"
                exit={{  zIndex: 0,
                  x: -1000,
                  opacity:0,
                }}
               
                >
                <StyledBackdrop>
                  <motion.div
                    variants={modal} 
                    >
                      <StyledModal1>
                      <GridContainer>
                      {setisSubmit(true)}
                        <GridItem xs={12} sm={12} md={3}>
                          <img alt='AskingPanda' width="40" height="100" className="card-img-top" src={baseUrl+'assets/images/pandaPic2.PNG'} />
                        </GridItem>
                        <GridItem xs={12} sm={12} md={9} sx={{ fontFamily: "Oswald" }}>
                            <h4>  Are you sure you want to go to next activity!!! </h4>
                            <Button color="success" variant="contained" onClick={closeModalYesThree} 
                              title="Click here to  proceed" style={{ fontSize: '10px' }} >
                                Yes
                            </Button>
                            <Button color="success" variant="contained" onClick={closeModalNoThree} 
                              title="Click here to  proceed" style={{ fontSize: '10px' }} >
                                No
                            </Button>
                          {/* </motion.div> */}
                        </GridItem>
                      </GridContainer>
                    </StyledModal1>
                    </motion.div>
                    </StyledBackdrop>  
                </motion.div>
              </AnimatePresence>)}
              
                <GridContainer>

                
                  <GridItem xs={12} sm={12} md={12}>
                    <GridContainer>
                      
                          
                            
                          <GridItem xs={12} sm={12} md={12}>
                            <GridContainer>
                              <Card>
                                <CardHeader color="success">
                                  <StyledcardTitle>
                                    <h4> Problem statement: {mydata.problemStatement}</h4>
                                  </StyledcardTitle>
                                </CardHeader>
                                <CardBody>
                              <GridContainer spacing={3}>
                                {mydata.decomposition[0].alternateSolution.map((text, index)=>{
                                  if(text.decomposition!='' && text.pattern!=''&& text.abstraction!='' && text.algorithm!=''){

                                  if(text.algorithm.includes('nitesh')==true){
                                    var newalgo=text.algorithm.split('nitesh')
                                  }
                                  var arr = text.analysis.split(',')
                                  var newarr1=arr[0].split('=')
                                  var newarr2=arr[1].split('=')
                                  var tim = newarr1[1]
                                  var spc = newarr2[1]
                                    return (
                                      text.algoCompleted==true?
                                      
                                      <GridItem xs={12} sm={6} md={4} key={index}>
                                          {totalSolutionComparison(text.decomposition,text.pattern,text.abstraction,newalgo[1],tim,spc,index+1,'1','decomposition')}
                                      </GridItem> 
                                      :null
                                    )}})}
                                  {mydata.pattern[0].alternateSolution.map((text, index)=>{
                                    if(text.decomposition!='' && text.pattern!=''&& text.abstraction!='' && text.algorithm!=''){
                                    var len=0;
                                    if(typeof(mydata.decomposition[0].alternateSolution.length)!='undefined'){
                                      len=mydata.decomposition[0].alternateSolution.length
                                    }
                                    if(text.algorithm.includes('nitesh')==true){
                                      var newalgo=text.algorithm.split('nitesh')
                                    }
                                    var arr = text.analysis.split(',')
                                    var newarr1=arr[0].split('=')
                                    var newarr2=arr[1].split('=')
                                    var tim = newarr1[1]
                                    var spc = newarr2[1]
                                    return (
                                    text.algoCompleted==true?
                                    <GridItem xs={12} sm={6} md={4} key={index}>
                                        {totalSolutionComparison(text.decomposition,text.pattern,text.abstraction,newalgo[1],tim,spc,index+1,'1','pattern')}
                                    </GridItem> 
                                     :null
                                  )}})}
                                  {mydata.abstraction[0].alternateSolution.map((text, index)=>{
                                    if(text.decomposition!='' && text.pattern!=''&& text.abstraction!='' && text.algorithm!=''){
                                  var len=0;
                                  if(typeof(mydata.decomposition[0].alternateSolution.length)!='undefined'){
                                    len=mydata.decomposition[0].alternateSolution.length
                                  }
                                  if(typeof(mydata.pattern[0].alternateSolution.length)!='undefined'){
                                    len=len+mydata.pattern[0].alternateSolution.length
                                  }
                                  if(text.algorithm.includes('nitesh')==true){
                                    var newalgo=text.algorithm.split('nitesh')
                                  }
                                  var arr = text.analysis.split(',')
                                  var newarr1=arr[0].split('=')
                                  var newarr2=arr[1].split('=')
                                  var tim = newarr1[1]
                                  var spc = newarr2[1]
                                  return (
                                  text.algoCompleted==true?
                                    <GridItem xs={12} sm={6} md={4} key={index}>
                                      {totalSolutionComparison(text.decomposition,text.pattern,text.abstraction,newalgo[1],tim,spc,index+1,'1','abstraction')}
                                    </GridItem>  
                                  :null
                                  )}})}
                                  {mydata.algorithm[0].alternateSolution.map((text, index)=>{
                                    if(text.decomposition!='' && text.pattern!=''&& text.abstraction!='' && text.algorithm!=''){
                                    var len=0;
                                    if(typeof(mydata.decomposition[0].alternateSolution.length)!='undefined'){
                                      len=mydata.decomposition[0].alternateSolution.length
                                    }
                                    if(typeof(mydata.pattern[0].alternateSolution.length)!='undefined'){
                                      len=len+mydata.pattern[0].alternateSolution.length
                                    }
                                    if(typeof(mydata.abstraction[0].alternateSolution.length)!='undefined'){
                                      len=len+mydata.abstraction[0].alternateSolution.length
                                    }
                                    if(text.algorithm.includes('nitesh')==true){
                                      var newalgo=text.algorithm.split('nitesh')
                                    }
                                    var arr = text.analysis.split(',')
                                    var newarr1=arr[0].split('=')
                                    var newarr2=arr[1].split('=')
                                    var tim = newarr1[1]
                                    var spc = newarr2[1]
                                    return (
                                    text.algoCompleted==true?
                                    <GridItem xs={12} sm={6} md={4} key={index}>
                                        {totalSolutionComparison(text.decomposition,text.pattern,text.abstraction,newalgo[1],tim,spc,index+1,'1','algorithm')}
                                    </GridItem> 
                                      :null
                                    )}})} 
                                    {mydata.analysis[0].completed===true?
                                          <GridItem xs={12} sm={6} md={4}>                                          
                                              {totalSolutionComparison(mydata.decomposition[0].userText,mydata.pattern[0].userText,mydata.abstraction[0].userText,mydata.algorithm[0].userText,mydata.analysis[0].timeText,mydata.analysis[0].spaceText,solutionIndex()+1,'1','correct')}
                                          </GridItem>             
                                    :null}
                                <GridItem xs={12} sm={12} md={4}>
                                    <Card>
                                    <CardHeader color="success">
                                      <StyledcardTitle>
                                        <h4> Overall Profile Score </h4>
                                      </StyledcardTitle>
                                    </CardHeader>
                                        <CardBody>
                                            {['1'].map((text,index)=>{
                                                var curractivity='activity'+actId
                                                var newactiv = totaldata[curractivity]
                                                var score = Number(newactiv[0].profileScore).toFixed(2)
                                                var num = actId
                                                var newact = parseInt(num)+1
                                                var newactivity='activity'+newact
                                                return(
                                                totaldata.currentActivity==curractivity?
                                                <div style={{ width: "70%" }}>
                                                    <CircularProgressbar
                                                            value={Number(mysum).toFixed(2)}
                                                            text={`${Number(mysum).toFixed(2)}%`}
                                                            background
                                                            backgroundPadding={6}
                                                            styles={buildStyles({
                                                            backgroundColor: "#3e98c7",
                                                            textColor: "#fff",
                                                            pathColor: "#fff",
                                                            trailColor: "transparent"
                                                            })}
                                                    /> 
                                                </div>:
                                                 <div style={{ width: "70%" }}>
                                                    <CircularProgressbar
                                                            value={score}
                                                            text={`${score}%`}
                                                            background
                                                            backgroundPadding={6}
                                                            styles={buildStyles({
                                                            backgroundColor: "#3e98c7",
                                                            textColor: "#fff",
                                                            pathColor: "#fff",
                                                            trailColor: "transparent"
                                                            })}
                                                        /> 
                                                </div>
                                                )                                                
                                               })}                        
                                                                                       
                                        </CardBody>
                                    </Card>
                                </GridItem>

                                </GridContainer>
                                
                                </CardBody>
                              </Card>
                            </GridContainer>
                          </GridItem>
                        
                          <GridItem xs={12} sm={12} md={12}>
                            <TableContainer component={Paper}>
                                    <Table sx={{ minWidth: 500 }} aria-label="customized table">
                                        <TableHead>
                                            <TableRow>
                                                <StyledTableCell>CT Step</StyledTableCell>
                                                <StyledTableCell align="right">Level of hints&nbsp;</StyledTableCell>
                                                <StyledTableCell align="right">Submission attempts</StyledTableCell>
                                                <StyledTableCell align="right">Time taken (in mins)&nbsp;</StyledTableCell>
                                                <StyledTableCell align="right">Submission attempts(Alternate solution)</StyledTableCell>
                                                <StyledTableCell align="right">Time taken (for Alternate solution in mins)&nbsp;</StyledTableCell>

                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                        {analytics.map((row) => (
                                             
                                            <StyledTableRow key={row.step}>
                                                <StyledTableCell component="th" scope="row">
                                                    {row.step}
                                                </StyledTableCell>
                                                <StyledTableCell align="right">{row.hints}</StyledTableCell>
                                                <StyledTableCell align="right">{row.attempts}</StyledTableCell>
                                                <StyledTableCell align="right">{row.time}</StyledTableCell>
                                                <StyledTableCell align="right">{row.altattempts}</StyledTableCell>
                                                <StyledTableCell align="right">{row.alttime}</StyledTableCell>
                                            </StyledTableRow>
                                        ))}
                                        </TableBody>
                                    </Table>
                            </TableContainer>
                           </GridItem>
                      </GridContainer>
                      
                      {isSubmit && <LinearProgress />}
                      {loading!==true?
                      <GridContainer>
                            <GridItem xs={12} sm={12} md={10}>
                            </GridItem>
                            <GridItem xs={12} sm={12} md={2}>
                              {actId==='7'||actId==='6'
                              ?null
                                    :<Button
                                    variant="contained"
                                    color="primary"
                                    size="lg"
                                    disabled={isSubmit}
                                    onClick={handleNext}
                                    active
                                  >
                                    Next Activity
                                  </Button>}
                              {actId==='6'
                              ? <Button
                                  variant="contained"
                                  color="primary"
                                  size="lg"
                                  onClick={handlePostTest}
                                  >
                                    Go to PostTest
                                </Button>:null}
                            </GridItem>
                      </GridContainer>:null}
                  </GridItem>

                  </GridContainer>

              
{/* ///////////////////////////////////////////////////////////////////////////////////////// */}

            </GridContainer>:null}
                                                                      

          </Form>
          )}
          </Formik>
          
    </div>:<GridContainer spacing={3}>
        <GridItem xs={12} sm={12} md={12}>
          <Skeleton variant="text" /> 
        </GridItem>
        <GridItem xs={12} sm={12} md={12}>
          <Skeleton variant="text" /> 
        </GridItem>
        <GridItem xs={12} sm={12} md={4}>
          <Box sx={{ width: 420, marginRight: 2, my: 5, padding: 2 }}>
            <Skeleton animation="wave" variant="rectangular" width={420} height={300} />    
          </Box>
          </GridItem>
          <GridItem xs={12} sm={12} md={4}>
          <Box sx={{ width: 420, marginRight: 2, my: 5 }}>
            <Skeleton animation="wave" variant="rectangular" width={420} height={300} />    
          </Box> 
          </GridItem>
          <GridItem xs={12} sm={12} md={4}>
          <Box sx={{ width: 420, marginRight: 2, my: 5 }}>
            <Skeleton variant="circular" width={420} height={300} />    
          </Box> 
        </GridItem>
        <GridItem xs={12} sm={12} md={12}>
          <Skeleton variant="text" /> 
        </GridItem>  
        <GridItem xs={12} sm={12} md={12}>  
          <Box sx={{ width: 1310, marginRight: 2, my: 5 }}>       
            <Skeleton animation="wave" variant="rectangular" width={1310} height={300} />    
          </Box>
        </GridItem>
      </GridContainer>
    );
}

